import { useCountryConfig } from 'queries/user/useCountryConfig';
import React from 'react';
import * as Sentry from '@sentry/react';
import { Outlet } from 'react-router-dom';
import { ClassroomsProvider } from '@teetsh/app/src/containers/App/context/ClassroomsContext';
import { useAppActions } from '@teetsh/app/src/containers/CarnetsDeNotes/useAppActions';
import { Onboarding } from './OnBoarding';
import { AddEleveDialog } from 'containers/Eleves/AddEleveDialog';
import ErrorFallback from 'components/Errors/ErrorFallback';

function ElevesRoot() {
  useAppActions();
  const { areOnboardingTutoEnabled } = useCountryConfig();

  return (
    <ClassroomsProvider>
      <Sentry.ErrorBoundary
        fallback={({ error }) => <ErrorFallback error={error} />}
      >
        {areOnboardingTutoEnabled && <Onboarding />}

        <AddEleveDialog />
        <Outlet />
      </Sentry.ErrorBoundary>
    </ClassroomsProvider>
  );
}

export { ElevesRoot as default };
